import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./orderLimitCell.scss";

const parseOrderLimit = (value) => {
    const trimmed = value.trim();
    if (trimmed === "") return null;

    const parsed = Number(trimmed);
    if (!Number.isInteger(parsed) || parsed < 0) return undefined;
    return parsed;
};

/** Edit one driver's order ceiling in the table. */
const OrderLimitCell = ({ value, onSave, disabled = false }) => {
    const isSet = value !== null && value !== undefined && value !== "";
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");
    const [saving, setSaving] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (editing && inputRef.current) inputRef.current.focus();
    }, [editing]);

    const open = () => {
        setDraft(isSet ? String(value) : "");
        setEditing(true);
    };

    const cancel = () => {
        setEditing(false);
        setDraft("");
    };

    const save = async () => {
        const next = parseOrderLimit(draft);
        if (next === undefined) return;

        setSaving(true);
        try {
            await onSave(next);
            setEditing(false);
        } finally {
            setSaving(false);
        }
    };

    if (editing) {
        return (
            <td className="order-limit-cell">
                <div className="order-limit-cell__edit">
                    <input
                        ref={inputRef}
                        type="number"
                        min="0"
                        step="1"
                        value={draft}
                        disabled={saving}
                        onChange={(event) => setDraft(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") save();
                            if (event.key === "Escape") cancel();
                        }}
                        placeholder="فارغ = بلا حد"
                        aria-label="حد الطلبات"
                    />
                    <button type="button" onClick={save} disabled={saving} title="حفظ">
                        <FontAwesomeIcon icon={faCheck} />
                    </button>
                    <button type="button" onClick={cancel} disabled={saving} title="إلغاء">
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
            </td>
        );
    }

    return (
        <td className="order-limit-cell">
            <button
                type="button"
                className={`order-limit-cell__value${isSet ? "" : " order-limit-cell__value--empty"}`}
                onClick={open}
                disabled={disabled}
                title={isSet ? "حد خاص — اضغط للتعديل" : "لا يوجد حد — اضغط للتحديد"}
            >
                <span className="order-limit-cell__number">
                    {isSet ? Number(value).toLocaleString("en-US") : "غير محدد"}
                </span>
                <FontAwesomeIcon icon={faPen} size="xs" />
            </button>
        </td>
    );
};

export default OrderLimitCell;
